module.exports = __webpack_public_path__ + "img/default-BVC.e0e53217.svg";